module.exports = __webpack_public_path__ + "static/media/experience.31798366.svg";